export const suppressProps = (...props) => ({
    shouldForwardProp: (prop) => !props.includes(prop),
});
//# sourceMappingURL=suppress-props.js.map